/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Sku_Pro_HintInputs */



/**
* | output |
* | --- |
* | "Pulse, and your whole team in the dashboard." |
*
* @param {Plan_Sku_Pro_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const plan_sku_pro_hint = /** @type {((inputs?: Plan_Sku_Pro_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Sku_Pro_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Pulse и вся ваша команда в панели.")
	return /** @type {LocalizedString} */ ("Pulse, and your whole team in the dashboard.")
});